import { Injectable } from '@angular/core';
import { INotificationsHub as INotificationsHub } from './i-notifications.hub';
import { SignalRHub as BaseSignalrHub } from '../common/hubs/signalr.hub';
import { Observable, Subject } from 'rxjs';
import { SignalRConnectionManager } from '../common/hubs/signalr-connection.manager';
import { INotificationMessage } from '../models/notification.message.model';

@Injectable({ providedIn: 'root' })
export class NotificationsHub extends BaseSignalrHub implements INotificationsHub {
    public messageReceived$;

    constructor(connectionManager: SignalRConnectionManager) {
        let messageRecievedSubject = NotificationsHub.ReceiveAsync();
        super({
            connectionManager,
            hubEvents: NotificationsHub.createHubEvents(messageRecievedSubject)
        });
        this.messageReceived$ = messageRecievedSubject.asObservable();
    }

    public joinGroups(groups: string[]): Observable<void> {
        return this.invokeMethod(this.joinGroups.name, groups);
    }

    public leaveGroups(groups: string[]): Observable<void> {
        return this.invokeMethod(this.leaveGroups.name, groups);
    }

    private static createHubEvents(subject: Subject<INotificationMessage<any>>) {
        return [
            {
                name: NotificationsHub.ReceiveAsync.name,
                subject: subject
            }
        ];
    }

    private static ReceiveAsync(): Subject<INotificationMessage<any>> {
        return new Subject<INotificationMessage<any>>();
    }
}
